import AutoCellRenderer from './AutoCellRenderer';
import ActionCellRenderer from './ActionCellRenderer';
import AutoIndexCellRenderer from './AutoIndexCellRenderer';
import AvatarCellRenderer from './AvatarCellRenderer';
import CustomCellRenderer from './CustomCellRenderer';
import DateCellRenderer from './DateCellRenderer';
import EnumCellRenderer from './EnumCellRenderer';
import GroupSelectionCellRenderer from './GroupSelectionCellRenderer';
import GroupSelectionHeader from './GroupSelectionHeader';
import MultiValueCellRenderer from './MultiValueCellRenderer';
import NumberCellRenderer from './NumberCellRenderer';
import NumericCellRenderer from './NumericCellRenderer';
import ProgressCellRenderer from './ProgressCellRenderer';
import StatusCellRenderer from './StatusCellRenderer';
import TextCellRenderer from './TextCellRenderer';
import UploadCellRenderer from './UploadCellRenderer';

export {
  AutoCellRenderer,
  ActionCellRenderer,
  AutoIndexCellRenderer,
  AvatarCellRenderer,
  CustomCellRenderer,
  DateCellRenderer,
  EnumCellRenderer,
  GroupSelectionCellRenderer,
  GroupSelectionHeader,
  MultiValueCellRenderer,
  NumberCellRenderer,
  NumericCellRenderer,
  ProgressCellRenderer,
  StatusCellRenderer,
  TextCellRenderer,
  UploadCellRenderer,
};

export const cellRenderMapping = {
  AutoCellRenderer,
  ActionCellRenderer,
  AutoIndexCellRenderer,
  AvatarCellRenderer,
  CustomCellRenderer,
  DateCellRenderer,
  EnumCellRenderer,
  MultiValueCellRenderer,
  NumberCellRenderer,
  NumericCellRenderer,
  ProgressCellRenderer,
  StatusCellRenderer,
  TextCellRenderer,
  UploadCellRenderer,
};
